/* eslint-disable import/prefer-default-export */
export const {
  REACT_APP_API_URL: API_URL,
  REACT_APP_API_SHOT_URL: API_SHOT_URL,
} = process.env;
